/**
 * Test utility for the CC4 file parser
 * This script tests the parser with a sample CC4 file
 */
import { parseCC4FileLocally } from './parseCC4FileLocally';

/**
 * Tests the CC4 parser with a sample file
 * @param {File} file - The CC4 file to test
 * @returns {Promise<Object>} - The parsed data
 */
export const testCC4Parser = async (file) => {
  try {
    console.log('Testing CC4 parser with file:', file.name);
    
    // Parse the file
    const result = await parseCC4FileLocally(file, (progress) => {
      console.log(`Parsing progress: ${progress}%`);
    });
    
    // Parse the result
    const parsedData = JSON.parse(result.result);
    
    // Log the extracted data
    console.log('Parsed CC4 Data:');
    console.log('-------------------');
    console.log('Patient Info:', parsedData.patientInfo);
    console.log('VO2 Max:', parsedData.vo2Max, parsedData.vo2MaxUnit);
    console.log('Heart Rate Max:', parsedData.heartRateMax);
    console.log('Heart Rate Rest:', parsedData.heartRateRest);
    console.log('Anaerobic Threshold:', parsedData.anaerobicThreshold);
    console.log('Anaerobic Threshold HR:', parsedData.anaerobicThresholdHR);
    console.log('Anaerobic Threshold %:', parsedData.anaerobicThresholdPercent);
    console.log('Predicted VO2 Max:', parsedData.predictedVO2Max);
    console.log('Predicted Max HR:', parsedData.predictedMaxHR);
    console.log('Recovery Heart Rates:', parsedData.recoveryHeartRates);
    console.log('Test Date:', parsedData.testDate);
    console.log('Test ID:', parsedData.testId);
    console.log('Report ID:', parsedData.reportId);
    console.log('Heart Rate Zones:', parsedData.heartRateZones);
    console.log('Data Samples Count:', parsedData.dataSamples?.length || 0);
    if (parsedData.dataSamples?.length > 0) {
      console.log('First Sample:', parsedData.dataSamples[0]);
      console.log('Last Sample:', parsedData.dataSamples[parsedData.dataSamples.length - 1]);
    }
    
    return parsedData;
  } catch (error) {
    console.error('Error testing CC4 parser:', error);
    throw error;
  }
};

/**
 * Creates a File object from a path for testing
 * @param {string} path - Path to the file
 * @returns {Promise<File>} - File object
 */
export const createFileFromPath = async (path) => {
  try {
    const response = await fetch(path);
    const blob = await response.blob();
    return new File([blob], path.split('/').pop(), { type: 'application/octet-stream' });
  } catch (error) {
    console.error('Error creating file from path:', error);
    throw error;
  }
};

// Example usage:
// const file = await createFileFromPath('/public/VO2CR-1060-000021ParekhRitesh.cc4');
// const parsedData = await testCC4Parser(file);
